import React, { useState } from "react";
import { Table, Tag } from "antd";
import ViewNumberPlating from "../../../NumberPlating/ViewNumberPlating";
import VehicleName from "../../../../VehicleName";

const AssociatedNumberPlates = ({ dataSource }) => {
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState({});

  const columns = [
    {
      title: "S.No",
      key: "sno",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "date",
      render: (date) => new Date(date).toLocaleDateString("en-GB"),
      width: 110,
    },
    {
      title: "Application No",
      dataIndex: "applicationNo",
      key: "applicationNo",
      width: 162,
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      width: 130,
    },
    {
      title: "Model Name",
      dataIndex: "modelName",
      key: "modelName",
      width: 260,
      render: (text) => <VehicleName nameOnly modelName={text} />,
    },
    {
      title: "Chassis No",
      dataIndex: "chassisNo",
      key: "chassisNo",
      width: 180,
    },
    {
      title: "Register No",
      dataIndex: "registerNo",
      key: "registerNo",
      width: 120,
    },
    {
      title: "Location",
      dataIndex: "Location",
      key: "Location",
      width: 120,
      render: (text) => text?.name,
    },
    {
      title: "Order Status",
      dataIndex: "plateOrderStatus",
      key: "plateOrderStatus",
      width: 80,
      render: (status) => (
        <Tag
          color={status === "ORDERED" ? "orange" : "green"}
          style={{
            width: "90px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {status}
        </Tag>
      ),
    },
  ];

  return (
    <div>
      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey="id"
        pagination={false}
        onRow={(record) => ({
          onClick: () => {
            setRowData(record);
            setOpen(true);
          },
        })}
        style={{ cursor: "pointer" }}
        scroll={{ x: "max-content" }}
      />

      {open && (
        <ViewNumberPlating
          open={open}
          close={() => setOpen(false)}
          rowData={rowData}
        />
      )}
    </div>
  );
};

export default AssociatedNumberPlates;
